// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.installment-container .installment-row {
  display: flex;
  align-items: center;
  margin-top: 1rem !important;
  min-height: 4rem;
}
@media (max-width: 992px) {
  .installment-container .installment-row .due-date-text-container h3 {
    text-align: right;
  }
}
@media (max-width: 575px) {
  .installment-container .installment-row .due-date-text-container h3:not(.success-text) {
    text-align: left;
  }
}
.installment-container .installment-row .installment-row-left-side {
  display: flex;
  align-items: center;
}
.installment-container .installment-row .installment-row-left-side .information-value-prefix {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0.063rem solid var(--primary-color);
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: var(--primary-color);
  font-weight: 500;
  margin-right: 1rem;
}
.installment-container .installment-row .installment-row-left-side .information-value-prefix.paid {
  color: #ffffff;
  border: 1px solid var(--success-color);
  background-color: var(--success-color);
}
.installment-container .installment-row .installment-row-left-side .information-value-prefix.paid img {
  filter: brightness(0) invert(1);
}
.installment-container .installment-row .installment-row-left-side .information-value-prefix.late {
  border-color: var(--danger-color);
  color: var(--danger-color);
}
@media (max-width: 768px) {
  .installment-container .installment-row .installment-row-left-side .information-value-prefix {
    width: 2.25rem;
    height: 2.25rem;
  }
}
.installment-container .installment-row .paid-value-preffix {
  font-size: 1.875rem;
  color: var(--success-color);
  margin-right: 1rem;
}
.installment-container .installment-row .actions-area .ant-row {
  width: 100%;
}
@media (max-width: 768px) {
  .installment-container .installments-divider {
    margin-top: 1.25rem;
    margin-bottom: 1.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/others/InstallmentRow/styles.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAAJ;AAGM;EAAA;IAEI,iBAAA;EADR;AACF;AAGM;EAEI;IACE,gBAAA;EAFV;AACF;AAfA;EAuBM,aAAA;EACA,mBAAA;AALN;AAnBA;EA2BQ,aAAA;EACA,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AANR;AAQQ;EACE,cAAA;EACA,sCAAA;EACA,sCAAA;AANV;AAGQ;EAMI,+BAAA;AANZ;AAUQ;EACE,iCAAA;EACA,0BAAA;AARV;AAWQ;EAAA;IACE,cAAA;IACA,eAAA;EARR;AACF;AAnDA;EAgEM,mBAAA;EACA,2BAAA;EACA,kBAAA;AAVN;AAxDA;EAuEQ,WAAA;AAZR;AAiBE;EAAA;IAEI,mBAAA;IACA,uBAAA;EAfJ;AACF","sourcesContent":[".installment-container {\n  .installment-row {\n    display: flex;\n    align-items: center;\n    margin-top: 1rem !important;\n    min-height: 4rem;\n\n    .due-date-text-container {\n      @media (max-width: @lg-screen) {\n        h3 {\n          text-align: right;\n        }\n      }\n      @media (max-width: 575px) {\n        h3 {\n          &:not(.success-text) {\n            text-align: left;\n          }\n        }\n      }\n    }\n\n    .installment-row-left-side {\n      display: flex;\n      align-items: center;\n\n      .information-value-prefix {\n        width: 2.5rem;\n        height: 2.5rem;\n\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        border: 0.063rem solid var(--primary-color);\n        font-size: 1.25rem;\n        line-height: 1.5rem;\n        color: var(--primary-color);\n        font-weight: 500;\n        margin-right: 1rem;\n\n        &.paid {\n          color: #ffffff;\n          border: 1px solid var(--success-color);\n          background-color: var(--success-color);\n\n          img {\n            filter: brightness(0) invert(1);\n          }\n        }\n\n        &.late {\n          border-color: var(--danger-color);\n          color: var(--danger-color);\n        }\n\n        @media (max-width: @md-screen) {\n          width: 2.25rem;\n          height: 2.25rem;\n        }\n      }\n    }\n\n    .paid-value-preffix {\n      font-size: 1.875rem;\n      color: var(--success-color);\n      margin-right: 1rem;\n    }\n\n    .actions-area {\n      .ant-row {\n        width: 100%;\n      }\n    }\n  }\n\n  @media (max-width: @md-screen) {\n    .installments-divider {\n      margin-top: 1.25rem;\n      margin-bottom: 1.875rem;\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
